import { Box, Divider, Stack } from "@mui/material";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";
import { ErrorBoundary } from "../../../components/ErrorBoundary";
import { useRightMenu } from "../../../components/Layout";
import { useMsg } from "../../../components/Msg/Msg";
import { ScrollableRightMenu } from "../../../components/ScrollableRightMenu";
import { H2, P } from "../../../components/Typography";
import { useStaticCallback } from "../../../hooks/useStaticCallback.hook";
import { Loaders } from "../../QM/QueryRenderer";
import {
  useIntegrationInfoQuery,
  useRecurringAvailabilityMutation,
  useRecurringAvailabilityQuery,
} from "../api";
import { AvailabilityPreview } from "../AvailabilityPreview";
import { settingsMessages } from "../messages";
import { AvailabilityRow } from "./AvailabilityRow";
import { CustomAvailabilityForm } from "./CustomAvailabilityForm";
import {
  INTEGRATION_TYPE,
  IntegrationStatusButton,
} from "./IntegrationStatusButton";
// import { TimePicker } from "@mui/x-date-pickers";

export const enabledName = (name) => `_enabled_${name}`;
export const dayRangesName = (name) => `_day_${name}`;

// for some reason, Stack displays dividers for chilren which return null
export const TLStack = ({ children, filterProp = "hidden", ...props }) => {
  const filteredChildren = React.Children.toArray(children).filter((child) => {
    return !child?.props?.[filterProp];
  });
  const sortedChildren = [...filteredChildren].sort(
    (a, b) => (a.props?.order || 0) - (b.props?.order || 0),
  );
  // console.log("[TLStack]", { children, filteredChildren, sortedChildren });

  return <Stack {...props}>{sortedChildren}</Stack>;
};

export const AvailabilitySettings = () => {
  const msg = useMsg({ dict: settingsMessages });
  const availabilityForm = useForm({});
  const recurringAvailabilityQuery = useRecurringAvailabilityQuery({});
  const recurringAvailabilityMutation = useRecurringAvailabilityMutation();

  const onError = (errors, e) =>
    console.log("[AvailabilitySettings.onError]", errors, e);

  const gcalQuery = useIntegrationInfoQuery({
    integrationType: INTEGRATION_TYPE.GOOGLE,
  });

  const onSaveClick = useStaticCallback((e) => {
    availabilityForm.handleSubmit((values, event) => {
      return recurringAvailabilityMutation.mutateAsync(values);
    }, onError)(e);
  });

  const saveDisabled = recurringAvailabilityMutation.isPending; // || !!query.error;

  console.log("[AvailabilitySettings.rndr]", {});

  useRightMenu(
    useMemo(
      () => (
        <ScrollableRightMenu
          heading={msg("settings.availability.aside.title")}
          buttonProps={{
            children: msg("settings.availability.aside.save"),
            type: "submit",
            disabled: saveDisabled,
            onClick: onSaveClick,
          }}
        >
          <ErrorBoundary fallbackRender={() => null}>
            <AvailabilityPreview />
          </ErrorBoundary>
        </ScrollableRightMenu>
      ),
      [msg, saveDisabled, onSaveClick],
    ),
  );

  if (gcalQuery.isPending || recurringAvailabilityQuery.isPending)
    return <Loaders.CircularBlock spaced />;

  return (
    <>
      <TLStack
        spacing={3}
        useFlexGap
        divider={<Divider orientation="horizontal" flexItem />}
      >
        {/* <Box>
          <H2 gutterBottom>{msg("settings.availability.heading")}</H2>
          <P>{msg("settings.availability.perex")}</P>
        </Box> */}
        <AvailabilityRow
          title={msg("settings.integrations.custom.title")}
          description={msg("settings.integrations.custom.description")}
          details={
            <CustomAvailabilityForm
              form={availabilityForm}
              recurringAvailabilityQuery={recurringAvailabilityQuery}
            />
          }
        />
        <AvailabilityRow
          avatarSrc={"/google-calendar.png"}
          title={msg("settings.integrations.google-calendar.title")}
          description={msg("settings.integrations.google-calendar.description")}
          control={
            <IntegrationStatusButton
              integrationType={INTEGRATION_TYPE.GOOGLE}
              query={gcalQuery}
            />
          }
        />
      </TLStack>
    </>
  );
};
